
import { Options, Vue } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, helpers } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PreviewAccountingReceipt from "../../components/PreviewAccountingReceipt.vue";
import { ref, defineComponent, toRefs, reactive } from "vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import {
    ItemList,
    CounterEntry,
    PaymentListType,
} from "../pos_purchase/IPurchaseReceipt";
import router from "../../router";
import { Watch } from "vue-property-decorator";
import { nextTick } from "vue";
import FileUploader from "../../components/FileUploader.vue";

@Options({
    title: "Purchases",
    components: {
        AutoComplete,
        SearchFilter,
        PreviewAccountingReceipt,
        PaymentScreen,
        ProfilerDialog,
        FileUploader,
    },
})
export default class PosPurchase extends Vue {
    private modeList = [
        { label: "PURCHASE", value: "PUR" },
        { label: "PURCHASE RETURN", value: "RPU" },
    ];

    private paymentDialog = false;
    private validationPopup = false;
    private validationPopupMessage =
        "Please fill all the required fields to proceed";
    private profileStatus = false;
    private statusType = "New";
    private storeName = "Loading...";
    private receiptDailog = false;
    private submitted = false;
    private currentUserID = 0;
    private itemScanBox = "";
    private profilerService;
    private posService;
    private toast;
    private storeList = [];
    private profilerList = [];
    private itemList = [];
    private productsList = [];
    private store = useStore();
    private invoiceDiscount: string = "";
    private cashPaymentOption = true;
    private cardPaymentOption = true;
    private chequePaymentOption = true;
    private payLaterOption = false;
    private paySupplierCredit = true;
    private supplierCreditAmount = 0;
    private uploaderStatus = false;
    private profileTypes = [{ key: "Supplier" }];
    private errorDialog = false;
    private validationErrors: any[] = [];
    private taxNames = [
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
    ];

    private excelFileContent = [
        {
            productName: "",
            reference: "",
            batchNo: "",
            barcode: "",
            unitQty: "",
            freeQty: "",
            supBonus: "",
            unitPurchase: "",
            unitDisc: "",
            mrp: "",
            cusDisc: "",
            expiryDate: "",
        },
    ];

    private productItem = {
        productName: "",
        reference: "",
        batchNo: "",
        barcode: "",
        unitQty: "",
        freeQty: "",
        supBonus: "",
        unitPurchase: "",
        unitDisc: "",
        mrp: "",
        cusDisc: "",
        expiryDate: "",
    };

    private state = reactive({
        selectedProfile: "",
        selectedProfileType: "",
        savedItemList: [] as ItemList[],
    });

    //private savedItemList: ItemList[] = [];

    private validationRules = {
        selectedProfile: {
            required,
        },
    };

    private counterEntry: CounterEntry[] = [];

    private paymentList: PaymentListType[] = [];

    private item = {
        id: 0,
        profileID: 0,
        discount: 0,
        totalPaid: 0,
        totalTendered: 0,
        totalChange: 0,
        totalGrossAmt: 0,
        totalBill: 0,
        totalGoodsValue: 0,
        totalTax1: 0,
        totalTax2: 0,
        totalTax3: 0,
        totalTax: 0,
        description: "",
        billNo: "",
        paymentMethod: "",
        searchReceiptNo: "",
        status: "Active",
        type: "PUR",
    };

    private v$ = useVuelidate(this.validationRules, this.state);

    //DEFAULT METHOD OF TYPE SCRIPT
    created() {
        this.profilerService = new ProfilerService();
        this.posService = new PosService();
        this.toast = new Toaster();
    }

    mounted() {
        this.loadList();

        localStorage.setItem("pur_items", "0");


        window.addEventListener('beforeunload', function (e) {
            // Check your localStorage flags
            const pur_item_list = localStorage.getItem('pur_items');
            if (pur_item_list == '1') {
                // Standard message (modern browsers ignore custom text)
                e.preventDefault();
                e.returnValue = '';
                // Some browsers require returnValue to be set
                return '';
            }
        });
    }

    openFileUploader() {
        ////console.log("open file uploader");
        this.uploaderStatus = true;
    }

    getDateAfterMonths(months) {
        const date = new Date();
        date.setMonth(date.getMonth() + months); // Add months to current date
        return date; // Return in YYYY-MM-DD format
    }

    get progressBar() {
        return this.store.getters.getProgressBar;
    }

    searchProfiler(event) {
        //console.log(event);
        setTimeout(() => {
            this.profilerService
                .searchProfiler(event.query.trim())
                .then((data) => {
                    // Filter records where account_type is "Supplier"
                    const suppliers = data.records.filter(
                        (record) => record.account_type === "Supplier"
                    );
                    if (suppliers.length > 0) {
                        this.profilerList = suppliers;
                        // for pharmacy supplier (default)
                        this.profilerList.forEach((profiler: any, index) => {
                            if (profiler.created_user == 0) {
                                profiler.supplier = profiler.supplier ?? {};
                                profiler.supplier.supplier_payable = 0;
                            }
                        });
                    } else {
                        this.profilerList = [];
                    }
                });
        }, 200);
    }

    searchItem(event) {
        ////console.log("searching purchase");
        setTimeout(() => {
            this.posService.searchPurItem(event.query.trim()).then((data) => {
                if (data.records.length == 0) {
                    this.itemList = [];
                    this.toast.showInfo("No Item Found");
                } else {
                    this.itemList = data.records;
                }
            });
        }, 200);
    }

    clearIfZero(item, field) {
        if (item[field] === 0) {
            item[field] = null; // Clear the value if it's 0
        }
    }

    saveProfile(event) {
        const profileInfo = event.value;
        this.state.selectedProfile = profileInfo.account_title;
        this.state.selectedProfileType = profileInfo.account_type;
        this.item.profileID = profileInfo.id;
        console.log(profileInfo);
        this.supplierCreditAmount = (profileInfo.supplier) ?profileInfo.supplier.supplier_payable:0; // - profileInfo.supplier.supplier_receivable
        this.paySupplierCredit = profileInfo.created_user == 0 ? false : true;
    }

    saveItem(event) {
        const itemInfo = event.value;

        this.state.savedItemList.push({
            mode: "Pack",
            stockID: 0,
            productID: itemInfo.id,
            productName: itemInfo.product_name,
            generic: itemInfo.generic_name,
            itemDescription: itemInfo.description,
            unit: 1,
            totalUnit: 0,
            stockQty: Number(itemInfo.qty),
            freeUnit: 0,
            supplierBonus: 0,
            batchNo: "", //String(Number(itemInfo.batch_no) + 1),
            barcode: "",
            packSize: 1, //Number(itemInfo.pack_size),
            sheetSize: 1, //Number(itemInfo.strip_size),
            purchasePrice: 0, //Number(itemInfo.purchase_price),
            orginalSPrice: 0, //Number(itemInfo.sale_price),
            sellingPrice: 0, //Number(itemInfo.sale_price),
            mrp: 0, //Number(itemInfo.mrp),
            brandName: itemInfo.bName,
            sectorName: itemInfo.bSector,
            categoryName: itemInfo.cName,
            productType: itemInfo.pType,
            expiryDate: itemInfo.expiry_date,
            cusDisc: 0, //Number(itemInfo.discount_percentage),
            minStockQty: Number(itemInfo.min_stock_qty),
            purchaseAfterDisc: 0,
            itemDisc: 0,
            tax1: 0, //Number(itemInfo.tax_1),
            tax2: 0, //Number(itemInfo.tax_2),
            tax3: 0, //Number(itemInfo.tax_3),
            subTotal: 0,
            expirable: 1, //Number(itemInfo.expirable),  REMOVING EXPIRABLE : JEEWAKA
        });

        localStorage.setItem("pur_items", "1");
        this.itemScanBox = "";
    }

    loadList() {
        this.posService.getItems().then((data) => {
            // //taxNames
            this.taxNames = [];

            this.storeList = data.stores;

            this.taxNames.push({
                taxName: data.storeTaxes[0].tax_name_1,
                show: data.storeTaxes[0].show_1 == "true" ? true : false,
                optionalReq: data.storeTaxes[0].required_optional_1,
                taxValue:
                    data.storeTaxes[0].show_1 == "true"
                        ? Number(data.storeTaxes[0].tax_value_1)
                        : 0,
                accountHead: data.storeTaxes[0].tax_name1.chartName,
                accountID: data.storeTaxes[0].link1,
            });

            this.taxNames.push({
                taxName: data.storeTaxes[0].tax_name_2,
                show: data.storeTaxes[0].show_2 == "true" ? true : false,
                optionalReq: data.storeTaxes[0].required_optional_2,
                taxValue:
                    data.storeTaxes[0].show_2 == "true"
                        ? Number(data.storeTaxes[0].tax_value_2)
                        : 0,
                accountHead: data.storeTaxes[0].tax_name2.chartName,
                accountID: data.storeTaxes[0].link2,
            });

            this.taxNames.push({
                taxName: data.storeTaxes[0].tax_name_3,
                show: data.storeTaxes[0].show_3 == "true" ? true : false,
                optionalReq: data.storeTaxes[0].required_optional_3,
                taxValue:
                    data.storeTaxes[0].show_3 == "true"
                        ? Number(data.storeTaxes[0].tax_value_3)
                        : 0,
                accountHead: data.storeTaxes[0].tax_name3.chartName,
                accountID: data.storeTaxes[0].link3,
            });

            this.currentUserID = data.currentUserID;
            this.storeName = data.storeName;
        });
    }

    getTheSubtotal(data) {
        const qty = Number(data.unit);
        const price = Number(data.purchasePrice);
        const discount = Number(data.itemDisc);
        const mrp = Number(data.mrp);

        const tax1 = data.tax1;
        const tax2 = data.tax2;
        const tax3 = data.tax3;
        const totalTax = tax1 + tax2 + tax3;

        const avgTax = 100 + totalTax;
        const tax = (mrp / avgTax) * totalTax;
        const packPrice = mrp - tax;

        const total = qty * price;
        const unitDiscAmount = (price / 100) * discount;
        const disAmount = (total / 100) * discount;

        const afterDis = total - disAmount;
        const afterTax = (afterDis / 100) * totalTax;

        const netTotal = afterDis + afterTax;

        data.subTotal = Number(this.fixDigits(netTotal));

        //TOTAL UNITS
        data.totalUnit =
            data.packSize * data.unit + data.freeUnit + data.supplierBonus;

        //PACK PRICE
        data.sellingPrice = Number(packPrice);

        //AFTER DISCOUNT PURCHASE PRICE
        data.purchaseAfterDisc = Number(this.fixDigits(price - unitDiscAmount));

        return this.fixDigits(netTotal);
    }

    get totalGross() {
        let total = 0;
        this.state.savedItemList.forEach((e) => {
            total = total + e.purchasePrice * e.unit;
        });

        return total;
    }

    get totalItemValue() {
        let total = 0;
        this.state.savedItemList.forEach((e) => {
            total = total + e.sellingPrice * e.unit;
        });

        return total;
    }

    get totalTax1() {
        let total = 0;

        this.state.savedItemList.forEach((e) => {
            const tax = e.tax1;
            const price = e.purchasePrice * e.unit;
            const afterDisc = (price / 100) * e.itemDisc;
            total = total + ((price - afterDisc) / 100) * tax;
        });

        return Number(total.toFixed(2));
    }

    get totalTax2() {
        let total = 0;
        this.state.savedItemList.forEach((e) => {
            const tax = e.tax2;
            const price = e.purchasePrice * e.unit;
            const afterDisc = (price / 100) * e.itemDisc;
            total = total + ((price - afterDisc) / 100) * tax;
        });

        return Number(total.toFixed(2));
    }

    get totalTax3() {
        let total = 0;
        this.state.savedItemList.forEach((e) => {
            const tax = e.tax3;
            const price = e.purchasePrice * e.unit;
            const afterDisc = (price / 100) * e.itemDisc;
            total = total + ((price - afterDisc) / 100) * tax;
        });

        return Number(total.toFixed(2));
    }

    get totalDiscAmount() {
        let total = 0;
        this.state.savedItemList.forEach((e) => {
            const price = e.purchasePrice * e.unit;
            total = total + (price / 100) * e.itemDisc;
        });

        return total;
    }

    get netTotal() {
        return Number(
            (
                this.totalGross -
                this.totalDiscAmount +
                this.totalTax1 +
                this.totalTax2 +
                this.totalTax3
            ).toFixed(2)
        );
    }

    get totalGoodsValue() {
        return Number(this.totalItemValue.toFixed(2));
    }

    fixDigits(amt) {
        let total = 0;

        if (amt != null) {
            total = amt.toFixed(2);
        }
        return total;
    }

    clearAll() {
        this.state.savedItemList = [];
        this.paymentList = [];

        this.item = {
            id: 0,
            profileID: 0,
            discount: 0,
            totalGrossAmt: 0,
            totalBill: 0,
            totalGoodsValue: 0,
            totalPaid: 0,
            totalTendered: 0,
            totalChange: 0,
            totalTax1: 0,
            totalTax2: 0,
            totalTax3: 0,
            totalTax: 0,
            description: "",
            billNo: "",
            searchReceiptNo: "",
            paymentMethod: "",
            status: "Active",
            type: this.item.type,
        };

        this.itemScanBox = "";
        this.state.selectedProfile = "";
        this.state.selectedProfileType = "";
        this.invoiceDiscount = "";

        localStorage.setItem("pur_items", "0");
    }

    formatExpiryDate(d) {
        return moment(d).format("MMM-YYYY");
    }

    clearListItem(item) {
        this.state.savedItemList.splice(
            this.state.savedItemList.indexOf(item),
            1
        );
        this.toast.showSuccess("Item Deleted Successfully");

        if (this.state.savedItemList.length == 0) {
            localStorage.setItem("pur_items", "0");
        }
    }

    limitString(str) {
        if (str.length > 40) str = str.substring(0, 40) + "...";
        return str;
    }

    closeValidationPopup() {
        this.validationPopup = false;
    }

    closePaymentScreen() {
        this.paymentDialog = false;
    }

    getProceededPayments(paymentList) {
        this.paymentList = paymentList;
        const tenderedList = this.getTotalPaid(paymentList);
        this.item.totalPaid = Number(tenderedList[0]);
        this.item.totalTendered = Number(tenderedList[1]);
        this.item.totalChange = Number(tenderedList[2]);

        const payedMethod = this.getPaymentMethod(paymentList);
        this.item.paymentMethod = payedMethod.payMethod;

        this.item.discount = this.totalDiscAmount;
        this.item.totalGrossAmt = this.totalGross;
        this.item.totalBill = this.netTotal;
        this.item.totalGoodsValue = this.totalGoodsValue;
        this.item.totalTax1 = this.totalTax1;
        this.item.totalTax2 = this.totalTax2;
        this.item.totalTax3 = this.totalTax3;
        this.item.totalTax = Number(
            this.totalTax1 + this.totalTax2 + this.totalTax3
        );

        this.setAccountingEntries();

        this.posService
            .savePurchaseItem(
                this.item,
                this.paymentList,
                this.state.savedItemList,
                this.counterEntry
            )
            .then((res) => {
                if (res.alert == "info") {
                    this.clearAll();
                }

                this.toast.handleResponse(res);
            });

        this.paymentDialog = false;
        this.submitted = false;
    }

    validateItems() {
        let validated = 1;
        let errorMessage = "";

        // check for duplicates
        const seen = new Set();
        this.state.savedItemList.filter((item) => {
            if (!(item.batchNo && item.mrp > 0 && item.purchasePrice > 0)) {
                errorMessage = "Please fill all the required fields to proceed"; // if item is already in the Set, it's a duplicate
                validated = 0;
            }
            if (!item.expiryDate && item.expirable) {
                errorMessage = "Please fill all the required fields to proceed"; // if item is already in the Set, it's a duplicate
                validated = 0;
            }
            if (
                seen.has(
                    "P" + String(item.productID) + "B" + String(item.batchNo)
                )
            ) {
                errorMessage =
                    "Batch Numbers cannot be duplicate for a single product"; // if item is already in the Set, it's a duplicate
                validated = 0;
            } else {
                seen.add(
                    "P" + String(item.productID) + "B" + String(item.batchNo)
                ); // if not, add it to the Set
                console.log("Duplicate Check:" + item.productID + item.batchNo);
            }
        });

        return { status: validated, message: errorMessage };
    }

    openPaymentMethod(isFormValid) {
        let validateDetails = this.validateItems();
        if (validateDetails.status == 0) {
            this.validationPopupMessage = validateDetails.message;
            this.validationPopup = true;
            return false;
        }

        this.submitted = true;
        if ((isFormValid = true)) {
            this.paymentDialog = true;
            this.store.dispatch(
                ActionTypes.TOTAL_BILL,
                Number(this.fixDigits(this.netTotal))
            );
        }
    }

    get totalPaidCash() {
        let total = 0;

        this.paymentList.forEach((e) => {
            if (e.paymentType == "Cash") {
                total = total + e.transTotalAmount;
            }
        });

        return total;
    }

    get totalPaidBank() {
        let total = 0;

        this.paymentList.forEach((e) => {
            if (e.paymentType != "Cash") {
                total = total + e.transTotalAmount;
            }
        });

        return total;
    }

    getTotalPaid(paymnetList) {
        let totalPaid = 0;
        let totalTendered = 0;
        let totalChange = 0;

        paymnetList.forEach((e) => {
            if (e.paymentType != "Tip") {
                totalPaid = totalPaid + Number(e.transTotalAmount);
                totalTendered = totalTendered + Number(e.tendered);
                totalChange = totalChange + Number(e.change);
            }
        });

        return [totalPaid, totalTendered, totalChange];
    }

    get totalBalance() {
        return this.netTotal - this.item.totalPaid;
    }

    getPaymentMethod(paymentList) {
        let payMethod = "";
        let payMethodId = 0;

        if (paymentList.length == 0) {
            payMethod = "Pay Later";
            payMethodId = 2;
        } else if (paymentList.length == 1) {
            payMethod = paymentList[0].paymentType;
            payMethodId = paymentList[0].paymentTypeID;
        } else if (paymentList.length > 1) {
            payMethod = "Split";
            payMethodId = 0;
        }

        return { payMethod: payMethod, paymentMethodId: payMethodId };
    }

    shiftPos() {
        if (this.item.type == "PUR") {
            this.toast.showSuccess("Mode Changed Successfully");
            this.clearAll();
        }
        if (this.item.type == "RPU") {
            window.open("/purchase-return", "_blank");
            this.item.type = "PUR";
        }
        this.submitted = false;
    }

    // fetchReceiptNo() {
    //   this.posService.getPurchaseItems(this.item.searchReceiptNo).then((data) => {
    //     if (data.receipt != null) {
    //       this.state.selectedProfile = data.receipt.profile_name.accountName;
    //       this.item.profileID = data.receipt.profile_name.id;
    //       this.item.billNo =
    //         data.receipt.bill_no == null
    //           ? ""
    //           : data.receipt.bill_no;
    //       this.item.description =
    //         data.receipt.description == null ? "" : data.receipt.description;
    //     }

    //     if (data.receiptItems != null) {
    //       ////console.log("SAVED RECEIPT ITEMS ",data.receiptItems);
    //       data.receiptItems.forEach((e) => {
    //         this.state.savedItemList.push({
    //           mode: e.mode,
    //           stockID: Number(e.stock_id),
    //           productID: Number(e.product_id),
    //           productName: e.item_name,
    //           generic: e.generic_name,
    //           itemDescription: e.item_description,
    //           unit: Number(e.unit),
    //           totalUnit: Number(e.total_unit),
    //           stockQty: Number(e.stock_detail.qty),
    //           freeUnit: Number(e.free_unit),
    //           supplierBonus: Number(e.supplier_bonus),
    //           batchNo: e.batch_no,
    //           barcode: e.barcode,
    //           packSize: Number(e.pack_size),
    //           sheetSize: Number(e.sheet_size),
    //           purchasePrice: Number(e.purchase_price),
    //           orginalSPrice: Number(e.stock_detail.sale_price),
    //           sellingPrice: Number(e.selling_price),
    //           mrp: Number(e.mrp),
    //           brandName: e.brand_name,
    //           sectorName: e.sector_name,
    //           categoryName: e.category_name,
    //           productType: e.product_type,
    //           expiryDate: e.expiry_date,
    //           itemDisc: Number(e.purchase_disc),
    //           purchaseAfterDisc: Number(e.after_disc),
    //           cusDisc: Number(e.item_disc),
    //           minStockQty: Number(e.min_stock_qty),
    //           tax1: Number(e.tax_1),
    //           tax2: Number(e.tax_2),
    //           tax3: Number(e.tax_3),
    //           subTotal: Number(e.sub_total),
    //           expirable: Number(e.expirable),
    //         });
    //       });

    //       // this.receiptDailog = false;
    //     }
    //   });
    // }

    //OPEN DIALOG TO ADD NEW ITEM
    openProfileDialog() {
        this.profileStatus = true;
        this.statusType = "New";
    }

    updateProfilerStatus(res) {
        this.profileStatus = false;
        if (res[0] == "load") {
            this.state.selectedProfile = res[1].account_title;
            this.state.selectedProfileType = res[1].account_type;
            this.item.profileID = res[1].id;
            // this.payLaterOption = true;
        }
    }

    redirectHome() {
        router.replace({ path: "/home/dashboard" });
    }

    get countTaxesLen() {
        let ctr = 0;

        if (this.taxNames[0].show) {
            ctr++;
        }

        if (this.taxNames[1].show) {
            ctr++;
        }

        if (this.taxNames[2].show) {
            ctr++;
        }

        return Number(ctr + 12);
    }

    setAccountingEntries() {
        this.counterEntry = [];

        if (this.item.type == "PUR") {
            this.counterEntry.push({
                accountID: 3,
                accountHead: "Inventory",
                amount: this.totalGross - this.totalDiscAmount,
                type: "Debit",
            });

            //ADDING TAXES
            if (this.totalTax1 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[0].accountID,
                    accountHead: this.taxNames[0].accountHead,
                    amount: this.totalTax1,
                    type: "Debit",
                });
            }

            if (this.totalTax2 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[1].accountID,
                    accountHead: this.taxNames[1].accountHead,
                    amount: this.totalTax2,
                    type: "Debit",
                });
            }

            if (this.totalTax3 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[2].accountID,
                    accountHead: this.taxNames[2].accountHead,
                    amount: this.totalTax3,
                    type: "Debit",
                });
            }

            if (this.totalBalance == 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Credit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Credit",
                    });
                }
            } else if (this.totalBalance == this.netTotal) {
                this.counterEntry.push({
                    accountID: 5,
                    accountHead: "Accounts payable",
                    amount: this.netTotal,
                    type: "Credit",
                });
            } else if (this.totalBalance > 0 && this.item.totalPaid > 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Credit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Credit",
                    });
                }

                this.counterEntry.push({
                    accountID: 5,
                    accountHead: "Accounts payable",
                    amount: this.totalBalance,
                    type: "Credit",
                });
            }
        } else if (this.item.type == "RPU") {
            if (this.totalBalance == 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Debit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Debit",
                    });
                }
            } else if (this.totalBalance == this.netTotal) {
                this.counterEntry.push({
                    accountID: 4,
                    accountHead: "Accounts receivable",
                    amount: this.netTotal,
                    type: "Debit",
                });
            } else if (this.totalBalance > 0 && this.item.totalPaid > 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Debit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Debit",
                    });
                }

                this.counterEntry.push({
                    accountID: 4,
                    accountHead: "Accounts receivable",
                    amount: this.totalBalance,
                    type: "Debit",
                });
            }

            this.counterEntry.push({
                accountID: 3,
                accountHead: "Inventory",
                amount: this.totalGross - this.totalDiscAmount,
                type: "Credit",
            });

            //ADDING TAXES
            if (this.totalTax1 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[0].accountID,
                    accountHead: this.taxNames[0].accountHead,
                    amount: this.totalTax1,
                    type: "Credit",
                });
            }

            if (this.totalTax2 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[1].accountID,
                    accountHead: this.taxNames[1].accountHead,
                    amount: this.totalTax2,
                    type: "Credit",
                });
            }

            if (this.totalTax3 != 0) {
                this.counterEntry.push({
                    accountID: this.taxNames[2].accountID,
                    accountHead: this.taxNames[2].accountHead,
                    amount: this.totalTax3,
                    type: "Credit",
                });
            }
        } else {
            //NOTHING
        }
    }

    get currency() {
        return this.store.getters.getCurrency;
    }

    handleInput(event: KeyboardEvent) {
        const inputField = event.target as HTMLInputElement;
        const pressedKey = event.key;

        nextTick(() => {
            const updatedValue = inputField.value; // Value after the keypress is applied
            // //console.log("Pressed Key:", pressedKey);
            // //console.log("Updated Value:", updatedValue);

            if (updatedValue === "" && pressedKey === "Backspace") {
                ////console.log("yes")
                //this.updateFirstPurchasePrice(0.00);
                //inputField.value = "0";
                //inputField.setSelectionRange(0, 0);
            }
            if (pressedKey === "." && updatedValue === "") {
                inputField.value = ".";
            }
        });
    }

    //OPEN DIALOG TO ADD NEW ITEM
    downloadSample() {
        this.posService.exportSampleStock().then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "samplePurchaseData.csv");
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    }

    //   updateUploaderStatus(params) {
    //   this.uploaderStatus = false;
    //   this.errorDialog=false;
    //   if (params.length > 0) {
    //     this.excelFileContent = [];

    //     this.posService.absoluteNo': e[2],
    //               'barcode': e[3],
    //               'unitQty': e[4],
    //               'freeQty': e[5],
    //               'supBonus': e[6],
    //               'unitPurchase': e[7],
    //               'unitDisc': e[8],
    //               'mrp': e[9],
    //               'cusDisc': e[10],
    //               'expiryDate': e[11],
    //             };

    //             // Run validation
    //             const errors = this.validateProductItem(this.productItem, productRefSet, index + 1);

    //             if (errors.length > 0) {
    //               this.validationErrors.push(...errors);
    //             } else {
    //               this.excelFileContent.push(this.productItem);
    //             }
    //           }
    //         });

    //         if (this.validationErrors.length > 0) {
    //           console.error('Validation Errors:', this.validationErrors);
    //           // Show these errors to the user in your preferred way
    //           //this.showErrorMessages(this.validationErrors);
    //           this.errorDialog=true;
    //         } else {
    //           this.fetchItemsFromExcel();
    //         }

    //         //console.log("VALIDATED FILE CONTENT", this.excelFileContent);
    //       }
    //     });
    //   }
    // }

    updateUploaderStatus(params) {
        this.uploaderStatus = false;
        this.errorDialog = false;

        if (params.length > 0) {
            this.excelFileContent = [];

            this.posService.uploadCSVFile(params[0]).then((res) => {
                if (res.length > 0) {
                    //const productIdSet = new Set();

                    const expectedHeaders = [
                        "Product Name",
                        "Reference(*)",
                        "Batch No(*)",
                        "Barcode",
                        "Unit Qty",
                        "Free Qty",
                        "Sup Bonus(Units)",
                        "Unit Purchase Price(*)",
                        "Unit Disc(%)",
                        "MRP(*)",
                        "Cus Disc(%)",
                        "Expiry Date(*)",
                    ];

                    const uploadedHeaders = res[0].map((header) =>
                        header.trim()
                    ); // Trim to avoid spaces
                    const headersMatch = expectedHeaders.every(
                        (header, index) => header === uploadedHeaders[index]
                    );

                    if (!headersMatch) {
                        // Invalid file: show error, stop processing
                        // this.$toast.add({
                        //   severity: 'error',
                        //   summary: 'Invalid CSV File',
                        //   detail: 'The CSV file headers do not match the expected format.',
                        //   life: 5000
                        // });
                        this.toast.showInfo("Invalid File Format");
                        console.error("Expected headers:", expectedHeaders);
                        console.error("Uploaded headers:", uploadedHeaders);
                        return; // Stop further processing
                    }

                    // // To track duplicates
                    const productRefSet = new Set();
                    this.validationErrors = [];

                    res.forEach((e, index) => {
                        if (index !== 0) {
                            // skip header row
                            this.productItem = {
                                productName: e[0],
                                reference: e[1],
                                batchNo: e[2],
                                barcode: e[3],
                                unitQty: e[4],
                                freeQty: e[5],
                                supBonus: e[6],
                                unitPurchase: e[7],
                                unitDisc: e[8],
                                mrp: e[9],
                                cusDisc: e[10],
                                expiryDate: e[11],
                            };

                            // Run validation
                            const errors = this.validateProductItem(
                                this.productItem,
                                productRefSet,
                                index + 1
                            );

                            if (errors.length > 0) {
                                this.validationErrors.push(...errors);
                            } else {
                                this.excelFileContent.push(this.productItem);
                            }
                        }
                    });

                    if (this.validationErrors.length > 0) {
                        console.error(
                            "Validation Errors:",
                            this.validationErrors
                        );
                        // Show these errors to the user in your preferred way
                        //this.showErrorMessages(this.validationErrors);
                        this.errorDialog = true;
                    } else {
                        this.fetchItemsFromExcel();
                    }

                    //console.log("VALIDATED FILE CONTENT", this.excelFileContent);
                }
            });
        }
    }

    isAlphanumeric = (value: any): boolean => {
        return value === "" || /^[A-Za-z0-9]+$/.test(value);
    };

    validateProductItem(item, productRefSet, rowIndex): string[] {
        const errors: string[] = [];

        // if (!this.isInteger(item.productId)) {
        //   errors.push(`Row ${rowIndex}: productId (${!item.productId?'empty':item.productId}) must be an integer.`);
        // } else {
        //   const idNum = Number(item.productId);
        //   if (productRefSet.has(idNum)) {
        //     errors.push(`Row ${rowIndex}: Duplicate productId (${item.productId}) found.`);
        //   } else {
        //     productRefSet.add(idNum);
        //   }
        // }

        if (!this.isAlphanumeric(item.reference)) {
            errors.push(
                `Row ${rowIndex}: Reference (${
                    !item.reference ? "empty" : item.reference
                }) must be alphanumeric.`
            );
        } else {
            //const idNum = Number(item.productId);
            // Remove duplicate reference check since its no needed
            // if (productRefSet.has(item.reference)) {
            //   errors.push(`Row ${rowIndex}: Duplicate reference (${item.reference}) found.`);
            // } else {
            //   productRefSet.add(item.reference);
            // }
        }

        // unitQty is required and must be integer
        if (!this.isInteger(item.unitQty)) {
            errors.push(
                `Row ${rowIndex}: unitQty (${item.unitQty}) must be an integer.`
            );
        }

        // freeQty can be optional but if provided must be an integer
        if (
            item.freeQty !== null &&
            item.freeQty !== "" &&
            item.freeQty !== undefined
        ) {
            if (!this.isInteger(item.freeQty)) {
                errors.push(
                    `Row ${rowIndex}: freeQty (${item.freeQty}) must be an integer if provided.`
                );
            }
        }

        // supBonus, unitDisc, cusDisc are optional but must be numbers if provided
        ["supBonus", "unitDisc", "cusDisc"].forEach((field) => {
            if (
                item[field] !== null &&
                item[field] !== "" &&
                item[field] !== undefined
            ) {
                if (!this.isNumeric(item[field])) {
                    errors.push(
                        `Row ${rowIndex}: ${field} (${item[field]}) must be a number if provided.`
                    );
                }
            }
        });

        if (!this.isNumeric(item.unitPurchase)) {
            errors.push(
                `Row ${rowIndex}: unitPurchase (${item.unitPurchase}) must be a number.`
            );
        }

        // Required fields: batchNo, unitPurchase, mrp, expiryDate
        ["batchNo", "unitPurchase", "mrp", "expiryDate"].forEach((field) => {
            if (!item[field] || item[field].toString().trim() === "") {
                errors.push(`Row ${rowIndex}: ${field} is required.`);
            }
        });

        const validatedDate = this.convertAndValidateDate(item.expiryDate);
        if (validatedDate && validatedDate[0] === '') {
            errors.push(
                `Row ${rowIndex}: ${validatedDate[1]}`
                // `Row ${rowIndex}: expiryDate (${item.expiryDate}) is not a valid date.`
            );
        }

        return errors;
    }

    convertAndValidateDate(dateStr: string): String [] | null {
        // Accept both single and double digits for month/day
        //console.log("DATE BEFORE ",dateStr);
        const mmddyyyyRegex =
            /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12]\d|3[01])\/\d{4}$/;

        if (!mmddyyyyRegex.test(dateStr)) {
            console.warn(
                `The date format should be Month/Date/Year, Ex: 01/31/2030`
            );
            return ['', 'The date format should be Month/Date/Year, Ex: 01/31/2030'];
        }

        const [month, day, year] = dateStr.split("/");

        // Pad month and day with zeros if needed
        const paddedMonth = month.padStart(2, "0");
        const paddedDay = day.padStart(2, "0");

        const shortYear = year.slice(-4);
        const formattedDate = `${paddedDay}-${paddedMonth}-${shortYear}`;

        // Validate minimum date (3 months ahead)
        const inputDate = new Date(`${year}-${paddedMonth}-${paddedDay}`);
        const today = new Date();
        const minDate = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());

        if (inputDate < minDate) {
            console.warn(
                `The expiry date must be at least 3 months ahead from today.`
            );
            return ['', 'The expiry date must be at least 3 months ahead from today'];
        }

        this.productItem.expiryDate = formattedDate;
        return [formattedDate, ''];
    }

    isInteger(value): boolean {
        if (value === null || value === undefined) return false;
        return Number.isInteger(Number(value));
    }

    isNumeric(value): boolean {
        if (value === null || value === undefined) return false;
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    isValidDate(dateStr): boolean {
        if (!dateStr) return false;

        const date = new Date(dateStr);
        return !isNaN(date.getTime());
    }

    showErrorMessages(errors: string[]): void {
        // You can implement this to show errors in your UI
        // Example: show in dialog or toaster notification
        alert(errors.join("\n")); // Simple alert for demonstration
    }

    // Extract product IDs and fetch items
    fetchItemsFromExcel() {
        // Extract 'productId' from each object in excelFileContent
        //console.log("EXCEL FILE CONTENT ", this.excelFileContent);
        const references = this.excelFileContent.map((item) => item.reference);

        if (references.length > 0) {
            this.getItemsByProductRef(references);
        } else {
            this.toast.showInfo("No Product IDs Found");
        }
    }

    getItemsByProductRef(references) {
        //console.log("PRODUCT Refs IN VUE ", references);
        setTimeout(() => {
            this.posService.getPurItems(references).then((data) => {
                if (data.records.length == 0) {
                    this.productsList = [];
                    this.toast.showInfo("No Item Found");
                } else {
                    this.productsList = data.records;
                    //console.log("PRODUCT LIST", this.productsList);
                    this.updateSavedItemList();
                }
            });
        }, 200);
    }

    updateSavedItemList() {
        //console.log("UPDATE SAVED ITEM LIST FUNCTION");
        //console.log("PRODUCTS LIST ", this.productsList);

        if (!this.productsList || this.productsList.length === 0) {
            this.toast.showInfo("No Product Data Available");
            return;
        }

        this.excelFileContent.slice().reverse().forEach((csvInfo: any, index) => {
            this.productsList.forEach((productInfo: any, prodInfoIdx) => {
                if (productInfo.reference == csvInfo.reference) {

                    this.state.savedItemList.push({
                        mode: "Pack",
                        stockID: 0,
                        productID: productInfo.id, // Assuming 'id' is the product ID
                        productName: productInfo.product_name, // Adjust according to actual data structure
                        generic: productInfo.generic_name,
                        itemDescription: productInfo.description,
                        unit: Number(csvInfo.unitQty),
                        totalUnit: 0,
                        stockQty: Number(productInfo.qty) || 0,
                        freeUnit: Number(csvInfo.freeQty),
                        supplierBonus: Number(csvInfo.supBonus),
                        batchNo: csvInfo.batchNo, // You can update this logic if needed
                        barcode: csvInfo.barcode,
                        packSize: 1, // Adjust if necessary
                        sheetSize: 1, // Adjust if necessary
                        purchasePrice: Number(csvInfo.unitPurchase), // Adjust if necessary
                        orginalSPrice: 0, // Adjust if necessary
                        sellingPrice: 0, // Adjust if necessary
                        mrp: Number(csvInfo.mrp), // Adjust if necessary
                        brandName: productInfo.bName,
                        sectorName: productInfo.bSector,
                        categoryName: productInfo.cName,
                        productType: productInfo.pType,
                        expiryDate: csvInfo.expiryDate,
                        cusDisc: Number(csvInfo.cusDisc), // Adjust if necessary
                        minStockQty: Number(productInfo.min_stock_qty) || 0,
                        purchaseAfterDisc: 0,
                        itemDisc: Number(csvInfo.unitDisc),
                        tax1: 0, // Adjust if necessary
                        tax2: 0, // Adjust if necessary
                        tax3: 0, // Adjust if necessary
                        subTotal: 0,
                        expirable: Number(productInfo.expirable),
                    });
                }
            });
        });
        this.toast.showSuccess(
            "Products added to purchase list successfully"
        );
    }
}
